<!-- #region Customer -->
<section [ngClass]="lang" class="customer p-5">
  <div class="container">
    <div class="wow fadeInDownBig m-auto col-12">
      <h2 *ngIf="lang == 'en'" class="text-center">
        Our Customers
      </h2>
      <h2 *ngIf="lang == 'ar'" class="text-center m-auto">
        عملائنا
      </h2>
    </div>

    <section [ngClass]="lang" class="customer-logos slider pt-5">
      <div class="slide" *ngFor="let item of data; index as i">
        <img *ngIf="lang=='en'" [src]="'./' + item.image" (load)="onLoading(i+'image')" [title]="item.title.en">
        <img *ngIf="lang=='ar'" [src]="'./' + item.image" (load)="onLoading(i+'image')" [title]="item.title.ar">
        <div [ngClass]="i+'image'" class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </section>

    <img data-lazy="../../../../assets/images/items/error.gif" />
  </div>
</section>
<!-- #endregion -->
